import React from 'react';
import {connect} from 'react-redux';
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";
import IndicatorUtils from "../../utils/IndicatorUtils";
import Spinner from "qwc2/components/widgets/Spinner";
import axios from "axios";
import isEmpty from 'lodash.isempty';
import {addLayerFeatures, LayerRole, removeLayer} from "qwc2/actions/layers";

class IndicatorRadar extends React.Component {

    static propTypes = {
        addLayerFeatures: PropTypes.func,
        additionalIndicators: PropTypes.array,
        indicators: PropTypes.array,
        removeLayer: PropTypes.func,
        selectedDate: PropTypes.string,
        selectedIndicator: PropTypes.object,
        selectedObjectType: PropTypes.string,
        selectedObjects: PropTypes.array
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true,
            url: '',
            calls: 0
        };
    }

    getIndicators() {
        const all = [];
        all.push({
            indicator: this.props.selectedIndicator,
            time: this.props.selectedDate,
        });
        this.props.additionalIndicators.forEach(ai => {
            all.push(ai);
        });
        return all;
    }

    getDataUrls() {
        const uuids = [];
        this.props.selectedObjects.forEach(o => uuids.push(o.properties.linkedObjectUuid));
        if (uuids.length == 0) {
            return [];
        }

        const urls = [];
        this.getIndicators().forEach(it => {
            const url = IndicatorUtils.getDataUrl(it.indicator, this.props.selectedObjectType, it.time, uuids);
            urls.push(url);
        });
        return urls;
    }

    updateChart() {
        const urls = this.getDataUrls();
        if (urls.length > 0) {
            const self = this;

            if (this.state.url != urls.join(',')) {
                self.setState({
                    calls: urls.length,
                    url: urls.join(',')
                });
            }

            urls.forEach(url => {
                axios(url).then(response => {
                    let calls = this.state.calls;
                    const data = this.state.data;
                    let loading = true;
                    calls--;
                    if (calls == 0) {
                        loading = false;
                    }

                    if (response.data && response.data.features) {
                        response.data.features.forEach(iv => {
                            const time = IndicatorUtils.normalizeDate(iv.properties.date);
                            const indicator = iv.properties.indicator;
                            const object = iv.properties.linkedObjectUuid;
                            if (!data[indicator]) {
                                data[indicator] = {};
                            }
                            if (!data[indicator][object]) {
                                data[indicator][object] = {};
                            }
                            if (!data[indicator][object][time]) {
                                data[indicator][object][time] = {};
                            }
                            data[indicator][object][time] = iv.properties.value;
                        });
                    }

                    self.setState({
                        data: data,
                        calls: calls,
                        isLoading: loading
                    });
                }).catch(error => {
                    console.log("Error *** : " + error);
                });
            });
        }
    }

    componentDidMount() {
        this.updateChart();
    }

    componentDidUpdate() {
        const urls = this.getDataUrls();
        if (urls.join(',') != this.state.url) {
            this.updateChart();
        }
    }

    render() {
        if (this.props.selectedObjects.length == 0) {
            return (
                <p style={{padding: '5px'}}>Bitte wählen Sie Objekte zum Vergleich aus.</p>
            );
        }
        return (
            <>
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                    </div>
                }
                {!this.state.isLoading &&
                    <>
                        {this.renderChart()}
                    </>
                }
            </>
        );
    }

    renderChart() {
        const that = this;
        const labels = [];
        const series = [];

        this.props.selectedObjects.forEach(object => {
            const name = object.linkedObject.properties.name || '';
            labels.push(name);

            const values = [];
            that.getIndicators().forEach(it => {
                const byIndicator = this.state.data[it.indicator.id];
                let val = 0;
                if (byIndicator && byIndicator[object.properties.linkedObjectUuid]) {
                    val = byIndicator[object.properties.linkedObjectUuid][IndicatorUtils.normalizeDate(it.time)] || 0;
                }
                values.push(val);
            });

            series.push({
                name: name,
                value: values
            });
        });
        const indicators = [];
        this.getIndicators().forEach(it => {
            indicators.push({
                name: it.indicator.name + '\n' + IndicatorUtils.normalizeDate(it.time)/*,
                max: it.indicator.maxValue,
                min: it.indicator.minValue*/
            });
        });
        const options = {
            tooltip: {
                trigger: 'item',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: labels
            },
            radar: {
                center: ['50%', '65%'],
                radius: '65%',
                indicator: indicators
            },
            series: [
                {
                    name: '',
                    type: 'radar',
                    data: series
                }
            ]
        };
        return (
            <ReactECharts
                style={{
                    height: '100%',
                    width: '100%'
                }}
                option={options}
                notMerge={false}
                lazyUpdate={false}
                opts={{locale: 'DE'}}
            />
        );
    }
}

const selector = (state) => ({
    indicators: state.indicators.indicators,
    selectedIndicator: state.indicators.selectedIndicator,
    selectedObjects: state.indicators.selectedObjects,
    selectedObjectType: state.indicators.selectedObjectType,
    selectedDate: state.indicators.selectedDate,
    additionalIndicators: state.indicators.additionalIndicators,
});

export default connect(selector, {
    addLayerFeatures: addLayerFeatures,
    removeLayer: removeLayer,
})(IndicatorRadar);
